import React from "react";
// import { Button, Grid, Box } from "@mui/material";
// import loginLoggo from "../../../MobileScreens/assets/images/loginLoggo.svg";

// import CorporateFareIcon from "@mui/icons-material/CorporateFare";
// import MailOutlineIcon from "@mui/icons-material/MailOutline";
// import LockOpenIcon from "@mui/icons-material/LockOpen";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import Checkbox from "@mui/material/Checkbox";
// import corTop from "../../../MobileScreens/assets/images/corTop.png";
// import corBot from "../../../MobileScreens/assets/images/corBot.png";
import { useNavigate } from "react-router-dom";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import Badge from "@mui/material/Badge";
import avttar from "../../../MobileScreens/assets/images/avtarPic.png";
import resipro from "../../assets/images/resiproIcon.svg";

function MobileHeader() {
  const navigate = useNavigate();

  return (
    <>
      <div className="mobFixedHeaderMain">
        <div className="mobHeaderMain">
          <div className="EventTimeView">
            <img src={resipro} className="HeaderlogoImage" alt='altimg'/>
            <h1 className="mobHeadHeading">Park Side Apartment</h1>
          </div>
          <Badge badgeContent={4} className="mobNotiS">
            <NotificationsNoneIcon style={{ color: "#fff" }} />
          </Badge>
        </div>
        <div className="mobSosMain" >
          <div className="mobSosLeft" onClick={() => navigate("/MobileProfile")}>
            <div className="mobSosPro">
              <img src={avttar} alt='altimg'/>
            </div>
            <div>
              <h1>John Doe</h1>
              <h2>
                <b>9881789836</b> <span>Owner Resident</span>
              </h2>
              <p>namratap.supra@gmail.com</p>
            </div>
          </div>
          <div className="mobSosMsgRight" onClick={()=>navigate('/MobileSosScreen')}>
            <em>SOS</em>
          </div>
        </div>
      </div>
      <div className="mobHeaderFixedPatch"></div>
    </>
  );
}

export default MobileHeader;
